import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 4000 },
    slideTime: { type: Number, default: 500 }
  }
  static targets = ["track", "dot"]

  connect() {
    this.currentIndex = 0
    this.total = this.trackTarget.children.length
    this.transitioning = false
    this.startAutoPlay()
  }

  disconnect() {
    this.stopAutoPlay()
  }

  startAutoPlay() {
    this.stopAutoPlay()
    this.autoPlayTimer = setInterval(() => this.next(), this.intervalValue)
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer)
      this.autoPlayTimer = null
    }
  }

  pause() {
    this.stopAutoPlay()
  }

  resume() {
    this.startAutoPlay()
  }

  next() {
    if (this.transitioning) return
    this.slideTo((this.currentIndex + 1) % this.total)
  }

  goTo(event) {
    event?.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (this.transitioning || index === this.currentIndex) return
    this.slideTo(index)
    this.stopAutoPlay()
    this.startAutoPlay()
  }

  slideTo(index) {
    this.transitioning = true
    this.trackTarget.style.transition = `transform ${this.slideTimeValue}ms ease-in-out`
    const offset = index * (100 / this.total)
    this.trackTarget.style.transform = `translateX(-${offset}%)`
    this.currentIndex = index
    this.updateDots()
    setTimeout(() => { this.transitioning = false }, this.slideTimeValue)
  }

  updateDots() {
    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, i) => {
        if (i === this.currentIndex) {
          dot.classList.add("bg-white")
          dot.classList.remove("bg-white/40")
        } else {
          dot.classList.remove("bg-white")
          dot.classList.add("bg-white/40")
        }
      })
    }
  }
}
